import React, { Component } from "react";
import { connect } from "react-redux";
import NavBars from "../components/Nav";

import { close_snack_bar } from "../../../common/snackbar/action";

import {
  login,
  forgotpassword,
  UserRegister,
  onLogout,
  setGoogleLoginData,
} from "../action";
export class Controller extends Component {
  render() {
    return <NavBars {...this.props} />;
  }
}
export const mapStateToProps = (store) => {
  return {
    loader: store.loader,
    snackbar: store.snackbar,
    QrCode: store.QrCode,
    login: store.login,
  };
};
export const mapDispatchToProps = (dispatch) => {
  return {
    close_snack_bar: () => {
      dispatch(close_snack_bar());
    },
    setGoogleLoginData: (payload, token) => {
      dispatch(setGoogleLoginData(payload, token));
    },
    UserRegister: (name, email, mobile, access) => {
      dispatch(UserRegister(name, email, mobile, access));
    },
    login: (email, password) => {
      dispatch(login(email, password));
    },
    forgotpassword: (email) => {
      dispatch(forgotpassword(email));
    },
    onLogout: () => {
      dispatch(onLogout());
    },
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Controller);
